export default "__VITE_ASSET__CWDrGZjz__"